import { CallEmsApi, iEmsApiResponse, iEmsApiResponseBody } from "../../Logic/EmsAPI/FetchExtension";
import { Departments, GetDepartments, GetMailboxes, MailboxList } from "../../Logic/EmsAPI/mailboxAccessRequest";
import store from "../../state/store";
import { getSessionValue, saveSessionValue } from "../../utilities/localStore/calls";

export interface GetUserResponse extends UserDTO {
    externalUserID: string;
    email: string;
    telephone: string;
    facsimile: string;
    mobile: string;
    shiftLength: number;
    blocked: boolean;
    disableAssignment: boolean;
    legacyUserSettings: string;
    departmentID: number;
    legacyRoleID: number;
    profile?: string;
    profile_email?: string;
    profile_jobTitle?: string;
    mailboxMembership: Array<mailboxMembership>;
    departmentName: string;
    globalRoleName: string;
}
export interface UserDTO {
    id: number;
    firstName?: string;
    lastName?: string;
}

// Maps to the backend's UserDTO (Firstname/Lastname), which camelCases differently to firstname/lastname.
export interface UpdateUserDTO {
    id: number;
    firstname?: string;
    lastname?: string;
}
export interface UpdateUserRequest extends GetUserResponse {}

export interface CreateMailboxAccessRequestRequest {
    UserID: number;
    MailboxID: number;
    MotivationComment?: string | null;
    RoleID: number;
}

export interface updateMailboxAccessRequest {
    id: number;
    accessRequestStatusID: number;
    userID: number;
    declineReason?: string | null;
}

export interface getMailboxAccessRequest {
    items: Array<MailboxAccessRequest>;
}

export interface MailboxAccessRequest {
    userID: number;
    mailboxID: number;
    dateCreated?: string | null;
    updatedAt?: string | null;
    motivationComment?: string | null;
    updateUserID?: number | null;
    accessRequestStatusID?: number | null;
    declineReason?: string | null;
    userMailboxAccessRequestID: number;
    userName?: string | null;
    accessRequestStatusName?: string | null;
    mailboxName?: string | null;
    roleName?: string | null;
    roleID?: number | null;
    mailboxManagerName?: string | null;
    user: GetUserResponse;
    updateUser?: UpdateUserDTO | null;
}

export enum requestStatus {
    Pending = 1,
    Approved = 2,
    Declined = 3,
    Deleted = 4,
}

export interface mailboxMembership {
    departmentName: string;
    roleName: string;
    mailboxName: string;
}

export async function GetUserProfileData(userid: number): Promise<iEmsApiResponseBody<GetUserResponse>> {
    return await CallEmsApi<GetUserResponse>("GET", `Users/${userid}/UserProfile`);
}

export async function UpdateUser(id: number, request: UpdateUserRequest): Promise<iEmsApiResponse> {
    return await CallEmsApi<any>("PUT", `Users/${id}/UserProfile`, request);
}

export async function CreateMailboxAccessRequest(request: CreateMailboxAccessRequestRequest): Promise<iEmsApiResponse> {
    return await CallEmsApi<any>("POST", `Users/MailboxAccessRequest`, request);
}

export async function MailboxAccessRequest(): Promise<iEmsApiResponseBody<getMailboxAccessRequest>> {
    let user = store.getState().UserInformation;
    return await CallEmsApi<getMailboxAccessRequest>("GET", `Users/${user.userID}/MailboxAccessRequest`);
}

export async function MailboxesAccessRequests(): Promise<iEmsApiResponseBody<getMailboxAccessRequest>> {
    let user = store.getState().UserInformation;
    return await CallEmsApi<getMailboxAccessRequest>("GET", `Users/${user.userID}/MailboxAccessRequestsManager`);
}

export async function getTenantMailboxes(): Promise<Array<MailboxList>> {
    const cachedMailboxes = getSessionValue<Array<MailboxList>>("tenantMailboxes");
    if (cachedMailboxes) {
        return cachedMailboxes;
    }

    const result = await GetMailboxes();
    const mailboxes = result.isOk && result.data ? result.data.items : [];
    saveSessionValue("tenantMailboxes", mailboxes);
    return mailboxes;
}

export async function getTenantDepartments(): Promise<Array<Departments>> {
    const cachedDepartments = getSessionValue<Array<Departments>>("tenantDepartments");
    if (cachedDepartments) {
        return cachedDepartments;
    }

    const result = await GetDepartments();
    const departments = result.isOk && result.data ? result.data.items : [];
    saveSessionValue("tenantDepartments", departments);
    return departments;
}

export async function UpdateMailboxAccessRequestStatus(
    requestId: number,
    request: updateMailboxAccessRequest,
): Promise<iEmsApiResponse> {
    return await CallEmsApi<any>("PUT", `Users/${requestId}/MailboxAccessRequest`, request);
}
